// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAnalytics } from 'firebase/analytics';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAh6NxnIfBeHD9wGtnyEJRb_S7vdwWcWTo",
  authDomain: "creedom-one-on-one-web.firebaseapp.com",
  projectId: "creedom-one-on-one-web",
  storageBucket: "creedom-one-on-one-web.firebasestorage.app",
  messagingSenderId: "242506688107",
  appId: "1:242506688107:web:45ec98015f93a21993f32e",
  measurementId: "G-JYRLST2ZR6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore with connection settings
const db = getFirestore(app);

// Initialize Analytics (optional)
let analytics;
if (typeof window !== 'undefined') {
  analytics = getAnalytics(app);
}

// Test Firebase connection on initialization
if (typeof window !== 'undefined') {
  console.log('Firebase initialized successfully');
  console.log('Firestore database:', db);
}

export { db, analytics };
export default app;
